export default __webpack_public_path__ + "static/media/tays-logo-gray.3f11c1fd.png";